import React from "react";
import styles from "../../../pages/styles";
import { zoomcall } from "../../../assets/images";

const About = ({ title, desc, img }) => {
  return (
    <div className="bg-darkprimary py-12 md:py-14 px-4 md:px-20">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center gap-10 md:gap-14">
        <div className="flex-1 text-center md:text-left">
          <h1 className={`${styles.biggerheadingwhite} mb-4 md:mb-5 relative`}>
            {title}
            <span className="relative inline-block z-10">
              Tech Tails
              <span className="absolute shadow-sm bottom-0 left-1 w-full h-2 bg-pinkprimary/80 -z-10 -skew-x-[30deg] rounded-sm"></span>
            </span>
          </h1>
          <p className={`${styles.paragraphwhite} max-w-xl mx-auto md:mx-0`}>{desc}</p>
        </div>
        <div className="flex-1 flex justify-center items-end">
          <img src={zoomcall} alt="About Tech Tails" className="w-full max-w-[400px] rounded-2xl shadow-xl" />
        </div>
      </div>
    </div>
  );
};

export default About;

{
  /* <h1 className={`${styles.headingdark}`}>
{heading}
<span className="underline decoration-pinkprimary decoration-8">
  Tech Tail
</span>
s
</h1> */
}
